import React, { Component } from "react"
import { Link } from "react-router-dom"
// import anbi from "../../../images/anbi.png"

import Title from "../../global/Title/Title"

class Footer extends Component {
  render() {
    return(
      <footer className="relative">
        {/* https://www.flaticon.com/packs/social-logo-2?k=1701681295301 */}
        <div className="animation-float animation-ease animation-infinite animation-fill-forwards animation-10s animation-delay-2s z-10 h-6 w-6 absolute -bottom-4 left-1/2 bg-orange rounded-full"></div>
        <div className="animation-float animation-ease animation-infinite animation-fill-forwards animation-8s z-10 h-20 w-20 absolute -bottom-4 left-7/12 bg-orange opacity-10 rounded-full"></div>
        <div className="hidden lg:block animation-float animation-ease animation-infinite animation-fill-forwards animation-5s animation-delay-2s z-0 h-12 w-12 absolute bottom-7/12 right-1/12 border-4 border-orange rounded-full"></div>
        <div className="max-w-screen-xl mx-auto px-4 sm:px-6 md:flex md:flex-wrap lg:px-8">
          <div className="w-full py-6 lg:py-12 flex flex-wrap lg:flex-no-wrap justify-between items-end">
            <div className="w-full xs:w-2/3 sm:2/4 lg:w-1/3">
              <Title className="xs:text-xl lg:text-4xl underlined">Vragen?</Title><br/>
              <Link to="/contact" className="hover:text-orange ease-in-out duration-300">
                <Title className="xs:text-xl lg:text-4xl underlined" level="3"> Neem contact op</Title>
              </Link>
            </div>
            <div className="flex items-center gap-4">
              <a href="https://www.linkedin.com/company/ronde-tafel-132/" target="_blank">
                <svg className="w-6 h-6" enableBackground="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="m23.994 24v-.001h.006v-8.802c0-4.306-.927-7.623-5.961-7.623-2.42 0-4.044 1.328-4.707 2.587h-.07v-2.185h-4.773v16.023h4.97v-7.934c0-2.089.396-4.109 2.983-4.109 2.549 0 2.587 2.384 2.587 4.243v7.801z" />
                  <path d="m.396 7.977h4.976v16.023h-4.976z" />
                  <path d="m2.882 0c-1.591 0-2.882 1.291-2.882 2.882s1.291 2.909 2.882 2.909 2.882-1.318 2.882-2.909c-.001-1.591-1.292-2.882-2.882-2.882z" />
                </svg>
              </a>
              <a href="https://www.instagram.com/rondetafel132/" target="_blank">
                <svg className="w-6 h-6" enableBackground="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="m12.004 5.838c-3.403 0-6.158 2.758-6.158 6.158 0 3.403 2.758 6.158 6.158 6.158 3.403 0 6.158-2.758 6.158-6.158 0-3.403-2.758-6.158-6.158-6.158zm0 10.155c-2.209 0-3.997-1.789-3.997-3.997s1.789-3.997 3.997-3.997 3.997 1.789 3.997 3.997c.001 2.208-1.788 3.997-3.997 3.997z" />
                  <path d="m16.948.076c-2.208-.103-7.677-.098-9.887 0-1.942.091-3.655.56-5.036 1.941-2.308 2.308-2.013 5.418-2.013 9.979 0 4.668-.26 7.706 2.013 9.979 2.317 2.316 5.472 2.013 9.979 2.013 4.624 0 6.22.003 7.855-.63 2.223-.863 3.901-2.85 4.065-6.419.104-2.209.098-7.677 0-9.887-.198-4.213-2.459-6.768-6.976-6.976zm3.495 20.372c-1.513 1.513-3.612 1.378-8.468 1.378-5 0-7.005.074-8.468-1.393-1.685-1.677-1.38-4.37-1.38-8.453 0-5.525-.567-9.504 4.978-9.788 1.274-.045 1.649-.06 4.856-.06l.045.03c5.329 0 9.51-.558 9.761 4.986.057 1.265.07 1.645.07 4.847-.001 4.942.093 6.959-1.394 8.453z" />
                  <circle cx="18.406" cy="5.595" r="1.439" />
                </svg>
              </a>
              {/* <Link to="/anbi-status-van-rt132">
                <img className="w-full h-12" src={anbi} alt="Logo ANBI"/>
              </Link> */}
            </div>
            <div className="w-full xs:w-1/3 sm:2/4 lg:w-1/3 lg:text-right">
              <p>Realisatie door: <a className="underlined font-bold" href="https://zekerzichtbaar.nl">Zeker Zichtbaar</a></p>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer
